/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './devices-map.scss';

/* eslint-disable import/no-unresolved, import/default, import/namespace */

import TbOpenStreetMap from '../../../openstreet-map';
import spearMarkerSvg from '../../svg/moisture-marker.svg';

/* eslint-enable import/no-unresolved, import/default, import/namespace */

export default angular.module('agrolog.farmer.allMeasurementsMap', [])
    .directive('allMeasurementsMap', AllMeasurementsMap)
    .name;

/*@ngInject*/
function AllMeasurementsMap () {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            measurements: "=",
            mapId: '<'
        },
        controller: AllMeasurementsMapController,
        controllerAs: 'vm'
    };
}
/* eslint-disable angular/angularelement */

/*@ngInject*/
function AllMeasurementsMapController($scope, $element, $filter, utils, agTypes) {// eslint-disable-line

    let vm = this;
    let mapContainer;
    let markers = [];
    let settings = {
        color: "#FE7569",
        currentImage: {
            url: spearMarkerSvg,
            size: 60
        },
        showLabel: true,
        labelColor: '#000',
        displayTooltip: true,
        autocloseTooltip: true
    };

    let markerClusteringSetting = {
        isMarketCluster: true,
        zoomToBoundsOnClick: true,
        showCoverageOnHover: true,
        animate: true,
        maxClusterRadius: 80,
        removeOutsideVisibleBounds: true
    };

    vm.cropNames = [];
    for (let property in agTypes.farmerCropNames) {
        vm.cropNames.push({
            nameId: property,
            value: agTypes.farmerCropNames[property]
        });
    }

    let initCallback = () => {
        updateMap();
        resizeMap();
    };

    $scope.$watch(() => { return vm.measurements.length ? vm.measurements : null; }, (measurements) => {
        if (vm.ctx && measurements) {
            reset();
            mapContainer = angular.element('#' + vm.mapId, $element);
            addResizeListener(mapContainer[0], resizeMap); // eslint-disable-line no-undef
            vm.ctx.map = new TbOpenStreetMap(mapContainer, utils, initCallback, null, null, null, 15, null, null, null, markerClusteringSetting, "satellite");
        }
    });

    function updateOrCreateMarkers() {
        let markerIndex = 0;
        let bounds = vm.ctx.map.createBounds();
        for (let i = 0; i < vm.measurements.length; i++) {
            if (vm.measurements[i].latitude && vm.measurements[i].longitude) {
                let markerLocation = vm.ctx.map.createLatLng(vm.measurements[i].latitude, vm.measurements[i].longitude);
                let settingsCopy = angular.copy(settings);
                settingsCopy.labelText = '<div style="position: relative; white-space: nowrap; text-align: center; font-size: 12px; top: 20px;"><span style="margin-left: -500%;"></span><span style="border: 2px solid #3498db; border-radius: 10px; color: #303c42; background-color: #fff; padding-left: 5px; padding-right: 5px; padding-top: 3px; padding-bottom: 3px;">' + vm.measurements[i].moistureContent + '%</span><span style="margin-right: -500%;"></span></div>\'';
                let measurementDate = $filter('date')(vm.measurements[i].ts, 'MM/dd/yyyy HH:mm');
                settingsCopy.tooltipPattern = "<b>" + measurementDate  + "</b><br/><br/><b>Crop type: </b><span style='color:#ed6d05;font-weight:600'>" + getCropName(vm.measurements[i].cropType) + "</span><br/><b>Moisture content: </b><span style='color:#3498db;font-weight:600'>" + vm.measurements[i].moistureContent + "%</span><br/><b>Latitude: </b>" + vm.measurements[i].latitude.toFixed(7) + "<br/><b>Longitude: </b>" + vm.measurements[i].longitude.toFixed(7) + "<br/><br/>";
                let marker =  vm.ctx.map.createMarker(markerLocation, markerIndex, settingsCopy);
                markers.push(marker);
                vm.ctx.map.extendBoundsWithMarker(bounds, marker);
                markerIndex++;
            }
        }
        vm.ctx.map.fitBounds(bounds);
    }

    function updateMap() {
        if (vm.ctx.map && vm.ctx.map.inited() && vm.measurements.length) {
            updateOrCreateMarkers();
            let tooltips = vm.ctx.map.getTooltips();
            for (let t = 0; t < tooltips.length; t++) {
                let tooltip = tooltips[t];
                let text = tooltip.locationSettings.tooltipPattern;
                tooltip.popup.setContent(text);
            }
        }
    }

    function resizeMap() {
        if (vm.ctx.map && vm.ctx.map.inited()) {
            vm.ctx.map.invalidateSize();
            let bounds = vm.ctx.map.createBounds();
            if (markers && markers.length > 0) {
                markers.forEach((marker) => {
                    vm.ctx.map.extendBoundsWithMarker(bounds, marker);
                });
            }
            vm.ctx.map.fitBounds(bounds);
        }
    }

    function getCropName(cropNameId) {
        if (vm.cropNames && vm.cropNames.length) {
            for (let i = 0; i < vm.cropNames.length; i++) {
                if (vm.cropNames[i].nameId === cropNameId) {
                    return vm.cropNames[i].value;
                }
            }
        }
        return "-";
    }

    function reset() {
        if (mapContainer) {
            removeResizeListener(mapContainer[0], resizeMap); // eslint-disable-line no-undef
        }
        if (vm.ctx.map) {
            vm.ctx.map.removeMap();
        }
        vm.ctx.map = null;
        markers = [];
    }
}